(function () {
	const config = {
		lazyClass: 'lazyload',
		loadedClass: 'lazyloaded',
		loadingClass: 'lazyloading',
		errorClass: 'lazyerror'
	};

	let elements: any;
	let loadMode = 2;
	let isCompleted: any;
	let resetPreloadingTimer: number | undefined;
	let started: any;
	let isBodyHidden: any;
	let currentExpand = 0;
	let isLoading = 0;
	let lowRuns = -1;

	const getCSS = function (elem: any, style: any) {
		return (getComputedStyle(elem) || {})[style];
	};

	const rAF = (function () {
		let running: boolean;
		let waiting: boolean;
		const firstFns: any[] = [];
		const secondFns: any[] = [];
		let fns = firstFns;

		const run = function () {
			const runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while (runFns.length) {
				runFns.shift()();
			}

			running = false;
		};

		const rafBatch: any = function (fn: any, queue?: any) {
			if (running && !queue) {
				fn();
			} else {
				fns.push(fn);

				if (!waiting) {
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	const throttle = function (fn: any) {
		let running: boolean;
		let lastTime = 0;

		const idleCallback = () =>
			rAF(() => {
				setTimeout(() => {
					running = false;
					lastTime = Date.now();
					fn();
				});
			});

		return function () {
			if (running) {
				return;
			}

			running = true;

			let delay = 125 - (Date.now() - lastTime);

			if (delay < 0) {
				delay = 0;
			}

			if (delay < 9) {
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	const debounce = function (func: any) {
		let timeout: any;
		let timestamp: any;
		const wait = 99;
		const run = function () {
			timeout = null;
			func();
		};
		const later = function () {
			const last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function () {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	const isNestedVisible = function (elem: any, elemExpand: any, rect: any) {
		let parent = elem;
		if (isBodyHidden == null) {
			isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
		}

		let visible = isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');

		const eLtop = rect.top - elemExpand;
		const eLbottom = rect.bottom + elemExpand;
		const eLleft = rect.left - elemExpand;
		const eLright = rect.right + elemExpand;

		while (visible && (parent = parent.offsetParent) && parent != document.body && parent != document.documentElement) {
			visible = (+getCSS(parent, 'opacity') || 1) > 0;

			if (visible && getCSS(parent, 'overflow') != 'visible') {
				const outerRect = parent.getBoundingClientRect();
				visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
			}
		}

		return visible;
	};

	const checkElements = function () {
		if (loadMode && isLoading < 8 && elements.length) {
			lowRuns++;

			const defaultExpand = document.documentElement.clientHeight > 500 && document.documentElement.clientWidth > 500 ? 500 : 370;
			const preloadExpand = defaultExpand * 1.5;
			isBodyHidden = null;

			if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
				currentExpand = preloadExpand;
				lowRuns = 0;
			} else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
				currentExpand = defaultExpand;
			} else {
				currentExpand = 0;
			}

			for (let i = 0; i < elements.length; i++) {
				if (!elements[i] || elements[i].dataset._lazyRace) {
					continue;
				}

				const rect = elements[i].getBoundingClientRect();

				if (
					rect.bottom >= currentExpand * -1 &&
					rect.top <= window.innerHeight + currentExpand &&
					rect.right >= currentExpand * -1 * 0.8 &&
					rect.left <= window.innerWidth + currentExpand * 0.8 &&
					(rect.bottom || rect.right || rect.left || rect.top) &&
					((isCompleted && isLoading < 3 && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(elements[i], currentExpand, rect))
				) {
					unveilElement(elements[i]);
					if (isLoading > 9) {
						break;
					}
				}
			}
		}
	};

	const throttledCheckElements = throttle(checkElements);

	const unveilElement = function (elem: HTMLImageElement) {
		if (elem.dataset._lazyRace) {
			return;
		}

		if (!isCompleted && !elem.complete && !elem.classList.contains(config.errorClass) && elem.classList.contains(config.lazyClass)) {
			return;
		}

		const src = getSizeElement(elem);

		elem.dataset._lazyRace = 'true';
		isLoading++;

		rAF(() => {
			elem.classList.add(config.loadingClass);

			const resetPreloading = function () {
				isLoading--;
				if (isLoading < 0) {
					isLoading = 0;
				}
			};

			clearTimeout(resetPreloadingTimer);
			resetPreloadingTimer = setTimeout(resetPreloading, 2500) as any;

			const switchLoadingClass = () => {
				if (elem.dataset._lazyCache) {
					delete elem.dataset._lazyCache;
					return;
				}

				resetPreloading();
				elem.classList.add(config.loadedClass);
				elem.classList.remove(config.loadingClass);
				['load', 'error'].forEach(function (evt) {
					elem.removeEventListener(evt, rafedSwitchLoadingClass);
				});

				elem.dispatchEvent(new Event('lazyloaded', { bubbles: true, cancelable: true }));
			};
			const rafedSwitchLoadingClass = () => rAF(() => switchLoadingClass());

			['load', 'error'].forEach(function (evt) {
				elem.addEventListener(evt, rafedSwitchLoadingClass);
			});

			elem.src = src;

			if (elem.dataset._lazyRace) {
				delete elem.dataset._lazyRace;
			}

			elem.classList.remove(config.lazyClass);

			rAF(() => {
				const isLoaded = elem.complete && elem.naturalWidth > 1;

				if (isLoaded) {
					switchLoadingClass();
					elem.dataset._lazyCache = 'true';
					setTimeout(() => {
						if (elem.dataset._lazyCache) {
							delete elem.dataset._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});
	};

	const load = function () {
		if (isCompleted) {
			return;
		}
		if (Date.now() - started < 999) {
			setTimeout(load, 999);
			return;
		}

		isCompleted = true;

		loadMode = 3;

		throttledCheckElements();

		const afterScroll = debounce(function () {
			loadMode = 3;
			throttledCheckElements();
		});

		window.addEventListener(
			'scroll',
			() => {
				if (loadMode == 3) {
					loadMode = 2;
				}
				afterScroll();
			},
			true
		);
	};

	/**
	 * Rounds dimension to the nearest breakpoint to reduce unique cached images.
	 * Uses a tiered approach: smaller increments for small sizes, larger for big sizes.
	 * @param dimension - The dimension value to round
	 * @returns Rounded dimension value
	 */
	const roundDimension = function (dimension: number): number {
		if (dimension <= 0) return 0;

		// Small images: round to nearest 50px (50, 100, 150, 200...)
		if (dimension <= 400) {
			return Math.ceil(dimension / 50) * 50;
		}
		// Medium images: round to nearest 100px (500, 600, 700...)
		else if (dimension <= 1200) {
			return Math.ceil(dimension / 100) * 100;
		}
		// Large images: round to nearest 200px (1400, 1600, 1800...)
		else if (dimension <= 2400) {
			return Math.ceil(dimension / 200) * 200;
		}
		// Extra large images: round to nearest 400px (2800, 3200...)
		else {
			return Math.ceil(dimension / 400) * 400;
		}
	};

	const getSizeElement = function (elem: HTMLImageElement) {
		let parent = elem.parentElement;
		const url = new URL(elem.dataset.src as string, document.baseURI);

		if (parent) {
			const originalWidth = +url.searchParams.get('width')!;
			const originalHeight = +url.searchParams.get('height')!;
			const hasOriginalRatio = originalWidth > 0 && originalHeight > 0;
			const dynamicWidth = elem.getAttribute('data-dynamic-width')?.toLowerCase() == 'true';
			const dynamicHeight = elem.getAttribute('data-dynamic-height')?.toLowerCase() == 'true';
			const pixelRatio = window.devicePixelRatio;
			let width = elem.offsetWidth;
			let height = elem.offsetHeight;

			while (width < 40 && parent) {
				width = parent.offsetWidth;
				height = parent.offsetHeight;
				parent = parent.parentElement;
			}

			let roundedWidth: number | null = null;

			if (dynamicWidth) {
				const calculatedWidth = width * pixelRatio;
				roundedWidth = roundDimension(calculatedWidth);
				url.searchParams.set('width', roundedWidth.toFixed(0));
			}
			if (dynamicHeight) {
				if (hasOriginalRatio && roundedWidth != null) {
					const ratioHeight = (originalHeight / originalWidth) * roundedWidth;
					url.searchParams.set('height', ratioHeight.toFixed(0));
				} else if (hasOriginalRatio && !dynamicWidth) {
					const roundedHeight = roundDimension(height * pixelRatio);
					const ratioWidth = (originalWidth / originalHeight) * roundedHeight;
					url.searchParams.set('height', roundedHeight.toFixed(0));
					url.searchParams.set('width', ratioWidth.toFixed(0));
				} else {
					const calculatedHeight = height * pixelRatio;
					const roundedHeight = roundDimension(calculatedHeight);
					url.searchParams.set('height', roundedHeight.toFixed(0));
				}
			} else {
				let newHeight = originalHeight * pixelRatio;

				if (hasOriginalRatio) {
					const baseWidth = roundedWidth ?? width * pixelRatio;
					newHeight = (originalHeight / originalWidth) * baseWidth;
				}

				if (newHeight !== 0) {
					const finalHeight = hasOriginalRatio && roundedWidth != null ? newHeight : roundDimension(newHeight);
					url.searchParams.set('height', finalHeight.toFixed(0));
				}
			}
		}

		return url.toString();
	};

	setTimeout(function () {
		elements = document.getElementsByClassName(config.lazyClass);

		window.addEventListener(
			'resize',
			debounce(function () {
				document.querySelectorAll<HTMLImageElement>(`.${config.loadedClass}`).forEach(e => {
					const url = getSizeElement(e);

					rAF(() => {
						e.src = url;
					});
				});
			})
		);

		window.addEventListener('scroll', throttledCheckElements, true);
		window.addEventListener('resize', throttledCheckElements, true);
		window.addEventListener('hashchange', throttledCheckElements, true);
		window.addEventListener('load', load);

		window.addEventListener('pageshow', function (e) {
			if (!e.persisted) {
				return;
			}
			const loadingElements = document.querySelectorAll<HTMLImageElement>('.' + config.loadingClass);

			requestAnimationFrame(function () {
				loadingElements.forEach(function (img) {
					if (img.complete) {
						unveilElement(img);
					}
				});
			});
		});

		new MutationObserver(throttledCheckElements).observe(document.documentElement, {
			childList: true,
			subtree: true,
			attributes: true
		});

		['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'DOMContentLoaded'].forEach(function (name) {
			document.addEventListener(name, throttledCheckElements, true);
		});

		if (/d$|^c/.test(document.readyState)) {
			load();
		} else {
			setTimeout(load, 20000);
		}

		checkElements();
		rAF._lsFlush();
	});
})();
